<template>
  <div
    class="flex items-center justify-center gap-x-1 whitespace-nowrap rounded-full border border-orange-500 bg-orange-50 px-1 py-1 text-xs text-orange-500"
  >
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M9.45716 3.76224C9.94251 2.9216 11.1559 2.9216 11.6412 3.76224L17.7566 14.3544C18.242 15.195 17.6353 16.2458 16.6646 16.2458H4.43382C3.46312 16.2458 2.85643 15.195 3.34178 14.3544L9.45716 3.76224Z"
          stroke="#FF9330"
          stroke-width="1.70371"
        />
        <path
          d="M10.5492 6.98199V11.6672"
          stroke="#FF9330"
          stroke-width="1.70371"
        />
        <circle
          cx="10.5513"
          cy="13.5832"
          r="1.06482"
          fill="#FF9330"
        />
      </svg>
    </div>
    <div>
      <p
        class="whitespace-nowrap text-xs text-orange-500"
        style="margin-top: 1px; margin-right: 3px"
      >
        {{ alert }} {{ alert > 1 ? 'Alerts' : 'Alert' }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AlertCounter',
  props: {
    alert: {
      type: String,
      required: true,
    },
  },
};
</script>
